import React, { useState } from "react";
import Cookies from "js-cookie";
import { clearPersistedSessionLoginId } from "./persistedLoginId";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAuthInvalidMessage } from "../Redux/features/Authentication/loginSlice";
import { format, parseISO } from "date-fns";
import { ToastifyAlert } from "../CommonComponents/ToastifyAlert";
import { isRequestCanceled } from "./isRequestCanceled";

export { isRequestCanceled };

/** Avoid toast spam when many API calls fail at once while offline. */
let lastNetworkToastAt = 0;
const NETWORK_TOAST_COOLDOWN_MS = 5000;

export function isNetworkError(error) {
  if (error == null) return false;
  // Aborted/canceled requests often have no response — do not treat as offline.
  if (isRequestCanceled(error)) return false;
  if (typeof error === "string") {
    const lower = error.toLowerCase();
    return (
      lower === "network error" ||
      lower.includes("err_internet_disconnected") ||
      lower.includes("err_network") ||
      lower.includes("failed to fetch")
    );
  }
  const status = error?.status;
  const message = String(error?.message || error?.payload || "");
  const code = String(error?.code || "");
  return (
    status === "Network Error" ||
    message === "Network Error" ||
    code === "ERR_NETWORK" ||
    code === "ECONNABORTED" ||
    /err_internet_disconnected|err_network|network error|failed to fetch/i.test(
      message,
    ) ||
    (typeof navigator !== "undefined" &&
      !navigator.onLine &&
      !error?.response)
  );
}

/** Module-level toast (safe outside React hooks). Cooldown avoids spam. */
export function toastNetworkError() {
  const now = Date.now();
  if (now - lastNetworkToastAt < NETWORK_TOAST_COOLDOWN_MS) {
    return;
  }
  lastNetworkToastAt = now;
  ToastifyAlert(
    "You're offline. Please check your internet connection and try again.",
    "error",
  );
}

export default function PasswordShow() {
  const dispatch = useDispatch();
  const [showpPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleMouseDown = () => {
    setShowPassword(true);
  };

  const handleMouseUp = () => {
    setShowPassword(false);
  };

  const jsxData = (value) => (
    <>
      <span
        className="Show-password"
        // onClick={handleClick}
        onMouseUp={handleMouseUp}
        onMouseDown={handleMouseDown}
      >
        {value !== "" ? (showpPassword ? "Hide" : "Show") : "Show"}
      </span>
    </>
  );

  const handleCoockieExpire = () => {
    try {
      localStorage.removeItem("permissionPresetData");
    } catch (e) {}
    Cookies.remove("loginDetails");
    Cookies.remove("token_data");
    Cookies.remove("user_auth_record");
    Cookies.remove("superadmin_details");
    clearPersistedSessionLoginId();
    // localStorage.removeItem("AllStore");
    // navigate("/login");
  };
  const getUnAutherisedTokenMessage = () => {
    dispatch(
      getAuthInvalidMessage("Your session has expired. Please log in again.")
    );
    ToastifyAlert("Your session has expired. Please log in again.", "error");
  };
  const getNetworkError = () => {
    toastNetworkError();
  };

  /** Shared API failure toast for catch blocks (401 / network / generic). */
  const handleApiError = (
    error,
    fallbackMsg = "Something went wrong. Please try again.",
  ) => {
    // Intentional abort — no toast (avoids "You're offline..." on cancel).
    if (isRequestCanceled(error)) return;
    if (error?.status == 401 || error?.response?.status === 401) {
      getUnAutherisedTokenMessage();
      handleCoockieExpire();
      return;
    }
    if (isNetworkError(error)) {
      getNetworkError();
      return;
    }
    const message =
      (typeof error === "string" && error) ||
      error?.message ||
      error?.payload ||
      fallbackMsg;
    // Never toast raw cancel messages that slipped past detection.
    if (isRequestCanceled(message)) return;
    ToastifyAlert(message, "error");
  };

  const ZoneWiseDate = (date, report) => {
    return !!date ? format(parseISO(date), "MM/dd/yyyy") : "-";
  };

  return {
    showpPassword,
    handleMouseDown,
    handleMouseUp,
    jsxData,
    handleCoockieExpire,
    getUnAutherisedTokenMessage,
    getNetworkError,
    handleApiError,
    ZoneWiseDate,
  };
}
